module.exports = new __parcel__URL__("Meeting notes Hover.418d408b.svg").toString();